import IconCopy from '../../../../icons/IconCopy';
export default IconCopy;